let searchAutofocusDirective = function () {
    return {
        restrict: 'A',
        link: function (scope, elem) {
            setTimeout(() => {
                elem[0].focus();
            }, 100);
        }
    };
};

export default searchAutofocusDirective;



// WEBPACK FOOTER //
// ./client/app/common/search-autofocus/search-autofocus.directive.js